import {
    IDotRezBookingSessionData
} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {PassengerTypeCodesEnum} from "../../../../passenger-types/passenger-type-codes.enum";
import {PassengerTypeMutator} from "./passenger-type-mutator";


export class PassengersTypesChangeMutation extends BookingMutationActionBase {

    async _runMutation(): Promise<Partial<IDotRezBookingSessionData>> {

        const adultsPassengersTypesMutators = this.booking.passengers.filter(p => p.passengerType.isAdult || p.allowPsoReducedMobility)
                                                                                          .map(p => new PassengerTypeMutator(p));
        const adultsWithReducedMobility = adultsPassengersTypesMutators.filter(ptm => ptm.hasReducedMobility);
        const adultsWithoutReducedMobility = adultsPassengersTypesMutators.filter(ptm => !ptm.hasReducedMobility);



        for(let withRM of adultsWithReducedMobility) {
            withRM.passenger.scheduledPassengerTypeChange = PassengerTypeCodesEnum.AdultWithReducedMobility;
        }

        let reducedMobilityCompanionsToResolve = Math.min(adultsWithReducedMobility.length, adultsWithoutReducedMobility.length);

        for(let withoutRM of adultsWithoutReducedMobility) {
            if(reducedMobilityCompanionsToResolve > 0) {
                if(withoutRM.applyReducedMobilityCompanion()) {
                    reducedMobilityCompanionsToResolve--;
                }
            } else {
                withoutRM.clearReducedMobilityCompanion();
            }
        }

        let childrenCompanionsCount  = Math.min(adultsWithoutReducedMobility.length, 2 *  this.booking.passengers.countChildren());

        for(let i= 0; i < childrenCompanionsCount; i++) {
            adultsWithoutReducedMobility[i].applyChildCompanion();
        }

        adultsPassengersTypesMutators.forEach(ptm => {
            if(ptm.passenger.scheduledPassengerTypeChange === ptm.passenger.passengerType.code) {
                ptm.passenger.scheduledPassengerTypeChange = null;
            }
        });

        const passengersToChangeType = adultsPassengersTypesMutators.filter(ptm => Boolean(ptm.passenger.scheduledPassengerTypeChange) && !ptm.passenger.hasErrors())
                                                                                         .map(ptm => ptm.passenger);
        if(passengersToChangeType.length === 0) {
            return {};
        }

        for(let passenger of passengersToChangeType) {

            try {
                await passenger.savePassengerDetails();
                await passenger.changePassengerType(passenger.scheduledPassengerTypeChange!);
            } catch (e) {
                this.services.logger.error(`Failed to change passengerType for passenger ${passenger.getFullName()}`, e);
            } finally {
                passenger.scheduledPassengerTypeChange = null;
            }
        }
        return await this.booking.session.bookingStateQueryBuilder().useAllAvailabilities().useCheckInRequirements().getBookingState();
    }

}